import { SET_GLOBALS } from "../constants";

export default function setGlobals(key, value) {
  return {
    type: SET_GLOBALS,
    key,
    value,
  };
}
